import { useEffect } from 'react';

const useHorizontalScroll = (
  ref: React.RefObject<HTMLElement>,
  itemCount: number
): void => {
  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const handleWheel = (event: WheelEvent): void => {
      if (element.scrollWidth <= element.clientWidth || event.deltaX !== 0) {
        return;
      }

      event.preventDefault();
      element.scrollLeft += event.deltaY;
    };

    element.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      element.removeEventListener('wheel', handleWheel);
    };
  }, [itemCount, ref]);
};

export default useHorizontalScroll;
